<template></template>
<script>
export default {
    props: ['trackingCode', 'analyticsCode', 'uniqueParam'],
    created: function() {
        if (this.$store.state.PRIVACY_MODULE) {
            this.$store.watch(
                () => this.$store.state.PRIVACY_MODULE.measurement,
                value => {
                    if (value === true) {
                        this.init();
                    }
                },
                {
                    immediate: true,
                },
            );
        } else {
            this.init();
        }
    },
    methods: {
        init() {
            if (this.$root.usedGoogleAnalyticsCodes == undefined) {
                this.$root.usedGoogleAnalyticsCodes = {};
            }
            if (this.$root.usedGoogleAnalyticsCodes[this.uniqueParam] == undefined) {
                this.$root.usedGoogleAnalyticsCodes[this.uniqueParam] = {};
            }

            if (
                (this.trackingCode != undefined &&
                    this.$root.usedGoogleAnalyticsCodes[this.uniqueParam][this.trackingCode] == undefined) ||
                (this.trackingCode == undefined &&
                    this.analyticsCode != undefined &&
                    this.$root.usedGoogleAnalyticsCodes[this.uniqueParam][this.analyticsCode] == undefined)
            ) {
                if (this.$root.usedGoogleAnalyticsCodes.script == undefined) {
                    (function(i, s, o, g, r, a, m) {
                        i['GoogleAnalyticsObject'] = r;
                        (i[r] =
                            i[r] ||
                            function() {
                                (i[r].q = i[r].q || []).push(arguments);
                            }),
                            (i[r].l = 1 * new Date());
                        (a = s.createElement(o)), (m = s.getElementsByTagName(o)[0]);
                        a.async = 1;
                        a.src = g;
                        m.parentNode.insertBefore(a, m);
                    })(window, document, 'script', 'https://www.google-analytics.com/analytics.js', 'ga');
                    this.$root.usedGoogleAnalyticsCodes.script = true;
                }

                if (this.trackingCode) {
                    ga('create', this.analyticsCode, 'auto', this.trackingCode);
                    ga(this.trackingCode + '.send', 'pageview');
                    this.$root.usedGoogleAnalyticsCodes[this.uniqueParam][this.trackingCode] = true;
                } else {
                    ga('create', this.analyticsCode, 'auto');
                    ga('send', 'pageview');
                    this.$root.usedGoogleAnalyticsCodes[this.uniqueParam][this.analyticsCode] = true;
                }
            }
        }
    }
};
</script>
